import type { FC } from 'react';

import { useGetControlById } from '@/hooks/queries/control/useGetControlById';

type Props = {
  controlId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ controlId }) => {
  if (!controlId) {
    throw new Error('controlId missing');
  }
  const { data } = useGetControlById(controlId);

  return <>{data?.control?.[0]?.Title}</>;
};

export default Breadcrumb;
